(function () {
  /* Match both V6 product-grid cards (.v-pcard) and Top Matches cards
     (.v-topm-card). Top Matches cards live in their own snippet and use
     a different root class, so without this every click was dropped
     silently at the `if (!card) return` guard below. */
  function findCard(btn) { return btn.closest('.v-pcard, .v-topm-card'); }

  async function addToCart(variantId, qty) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
    });
    if (!res.ok) throw new Error('Cart add failed: ' + res.status);
    return res.json();
  }

  function flashAdded(btn) {
    btn.classList.remove('is-adding');
    btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
  }

  function updateCartBubble() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      var bubbles = document.querySelectorAll('[data-cart-count], [data-js-cart-count]');
      bubbles.forEach(function (b) { b.textContent = cart.item_count; });
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-quick-add]');
    var buyBtn = e.target.closest('[data-buy-now]');
    if (!addBtn && !buyBtn) return;
    e.preventDefault();
    e.stopPropagation();

    var btn = addBtn || buyBtn;
    var card = findCard(btn);
    if (!card) return;

    /* Read variant + product info from the BUTTON first — Top Matches
       cards (.v-topm-card) put data-variant-id and data-product-handle
       on the button itself, not on the card root. Fall back to CARD
       attrs for the v-pcard convention so existing grids keep working. */
    var variantId = btn.getAttribute('data-variant-id') || card.getAttribute('data-variant-id');
    var variantsCount = parseInt(card.getAttribute('data-variants-count'), 10) || 1;
    var productHandle = btn.getAttribute('data-product-handle') || card.getAttribute('data-handle');
    var productUrl = card.getAttribute('data-product-url') || (productHandle ? '/products/' + productHandle : '');

    if (variantsCount > 1) {
      window.location = productUrl;
      return;
    }
    if (!variantId) {
      window.location = productUrl;
      return;
    }

    btn.classList.add('is-adding');
    addToCart(variantId, 1).then(function () {
      if (buyBtn) {
        window.location = '/checkout';
        return;
      }
      flashAdded(btn);
      updateCartBubble();
    }).catch(function (err) {
      btn.classList.remove('is-adding');
      console.error('[cust-v6-quick-add]', err);
      window.location = productUrl;
    });
  });
})();

